(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp
      );
      this.reelId = parseInt(reelId.replace("reel", ""));
      this._moonValueOverlays = [];
      this._showMoon = false;
    }

    checkIfLandedCoin(slotCell) {
      let coinValue = undefined;
      gameController.coinValues.forEach(function (coin) {
        if (coin.slotCell === slotCell) {
          coinValue = {
            amount: coin.amount,
            type: coin.type,
            potName: coin.potName,
          };
        }
      });
      return coinValue;
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);

      for (let i = 0; i < ids.length; ++i) {
        let symId = ids[i];

        if (
          gameData.symbols &&
          gameData.symbols["Symbol_Coin"].ID === symId &&
          i === 0
        ) {
          let coinData = this.checkIfLandedCoin(this.reelId);
          let value;
          if (coinData) {
            value = coinData;
          } else {
            let stake = gameController.getCurrentModeStake(true);
            const baseVal =
              gameData.possibleCashValues[
                Math.floor(Math.random() * (6 - 0 + 1) + 0)
              ];
            value = (baseVal * stake) / 100;
          }
          if (value.type === "Cash") {
            gameController.valuesSpin.setCoinCLSpinValue(
              this.reelId,
              value.amount
            );
          } else if (gameController.cashLinkReelIsSpinSpinning[this.reelId]) {
            gameController.valuesSpin.setCoinCLSpinValue(this.reelId, value);
            gameController.valuesSpin.showSpinCLCoinValue(true, this.reelId);
          }
        } else if (
          gameData.symbols &&
          gameData.symbols["Symbol_Coin"].ID != symId &&
          i === 0
        ) {
          gameController.valuesSpin.showSpinCLCoinValue(false, this.reelId);
        }
      }
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType(
    "ReelSpinnerVisualSCS",
    create,
    initialise,
    getRequiredFiles
  );
})();
